import { render } from "./recommendationsTeaser.vue?vue&type=template&id=32944881"
import script from "./recommendationsTeaser.vue?vue&type=script&lang=js"
export * from "./recommendationsTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__